import HighlightMessage from './HighlightMessage'

export default HighlightMessage
// eslint-disable-next-line import/export
export * from './HighlightMessage'
